import { includeDiscontinuedFilterRegexp } from "../constants/search-filter-regexp";
import { getFilterIndex } from "./get-filter-index";
export var getIncludeDiscontinuedFilterIndex = function (filters) {
    return getFilterIndex(filters, includeDiscontinuedFilterRegexp);
};
